import { useState } from "react";
import type { ModalContent } from "./Modal";

export interface UseModalReturn {
  isOpen: boolean;
  openModal: (content?: ModalContent | false) => void;
  closeModal: () => void;
  modalContent: ModalContent | false;
  hideCloseButton: () => void;
  showCloseButton: boolean;
}

const useModal = (): UseModalReturn => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState<ModalContent | false>(false);
  const [showCloseButton, setShowCloseButton] = useState(true);

  const closeModal = () => {
    setIsOpen(false);
    setShowCloseButton(true);
  };

  const openModal = (content: ModalContent | false = false) => {
    setIsOpen(true);
    if (content) {
      setModalContent(content);
    }
  };

  const hideCloseButton = () => {
    setShowCloseButton(false);
  };

  return {
    isOpen,
    openModal,
    closeModal,
    modalContent,
    hideCloseButton,
    showCloseButton,
  };
};

export default useModal;
